<template>
    <div>
        <app-finalizacoes
            v-show="mostrarFinalizacoes"
            :finalizacoes="finalizacoes"
            :totaisStatus="totaisStatus"
            :finalizacoesServicos="obterFinalizacoesServicos()"
            :showCredenciado="false"
            @detalharFinalizacao="detalharFinalizacao($event)"
            @atualizarListagem="obterFinalizacoes()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Situacao</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="situacoesFinalizacoesSelect"
                                v-model="situacaoFinalizacoes"
                            ></b-form-select>
                        </b-form-group>
                    </b-col> -->
                    <!-- <b-col sm="12" md="4">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusFinalizacoesSelect"
                                v-model="statusFinalizacoes"
                            ></b-form-select>
                        </b-form-group>
                    </b-col> -->
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('CRED-FORN-FIN-02')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharFinalizacao(data.finalizacaoId)"
                    ></i>
                </span>
            </template>
        </app-finalizacoes>
        <router-view></router-view>
    </div>
</template>

<script>
import FinalizacoesServicos from './FinalizacoesServicos'
import Finalizacoes from '@/app/credenciados/componentes/finalizacoes/Finalizacoes'

export default {
    data() {
        return {
            finalizacoes: [],
            dataInicial: null,
            dataFinal: null,
            setInicial: true,
            totaisStatus: {}
        }
    },

    methods: {
        obterFinalizacoesServicos() {
            return FinalizacoesServicos
        },

        obterFinalizacoes() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            FinalizacoesServicos.obterTodas(filtroDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.finalizacoes = response.data.finalizacoes
                        this.totaisStatus = response.data.totaisStatus
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharFinalizacao(id) {
            this.$router.push({
                name: `Credenciados_Finalizacoes_Detalhar`,
                params: {
                    finalizacaoId: id
                }
            })
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .subtract(1, 'months')
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
        this.setInicial = false
        this.obterFinalizacoes()
    },

    computed: {
        mostrarFinalizacoes() {
            return this.$route.name === 'Credenciados_Finalizacoes'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Credenciados_Finalizacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterFinalizacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setInicial) {
                this.obterFinalizacoes()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setInicial) {
                this.obterFinalizacoes()
            }
        }
    },

    components: {
        AppFinalizacoes: Finalizacoes
    }
}
</script>
